const TrashIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.125 5.625H14.625C15.1773 5.625 15.625 5.17728 15.625 4.625V4.125C15.625 3.57272 15.1773 3.125 14.625 3.125H11.625M14.125 5.625V17.625C14.125 18.7296 13.2296 19.625 12.125 19.625H4.125C3.02043 19.625 2.125 18.7296 2.125 17.625V5.625M14.125 5.625H2.125M11.625 3.125V2.625C11.625 1.52043 10.7296 0.625 9.625 0.625H6.625C5.52043 0.625 4.625 1.52043 4.625 2.625V3.125M11.625 3.125H4.625M2.125 5.625H1.625C1.07272 5.625 0.625 5.17728 0.625 4.625V4.125C0.625 3.57272 1.07272 3.125 1.625 3.125H4.625M6.125 9.125V16.125M10.125 9.125V16.125"
        stroke="black"
        stroke-width="1.25"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default TrashIcon;
